// extracted by mini-css-extract-plugin
export default {"search_box":"SearchBox_search_box__Ue0cx"};